const referrals = {
    colsOrder: ['logo', 'title', 'type', 'dates', 'status'],
    cols: {
        logo: {
            content: 'Лого',
            width: (admin: boolean) => (admin ? 15 : 18),
        },
        title: {
            content: 'Название',
            width: (admin: boolean) => (admin ? 39 : 36),
            isAdminMain: true,
        },
        type: {
            content: 'Тип',
            width: 20,
        },
        dates: {
            content: 'Период',
            width: 12,
        },
        status: {
            content: 'Статус',
            width: 14,
        },
    },
    adminIndex: 1,
    deletesCols: [],
    url: 'referral',
    emptyInfo: {
        title: 'Акций пока нет',
        description: 'Вы можете создать акцию по кнопке справа',
    },
} as const;

export default referrals;
